import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { getFormValues } from 'redux-form'
import HelpTicketForm from './HelpTicketForm'
import { getOS, getBrowser } from 'app/utils/browserUtils'
import { userTypeString, formatNameFull, phoneNumberStringFromUser } from 'app/utils/userUtils'
import LgyLoadingFallback from 'app/components/util/lgy-loading-fallback/LgyLoadingFallback'

const HelpTicketContainer = (props) => {
  const { initialFormValues, values, user, serverProperties, userIsLoggedIn, isCsmEnabledForAnonymousUsers, isCsmEnabled  } = props

  if ((!userIsLoggedIn && isCsmEnabledForAnonymousUsers) || (userIsLoggedIn && isCsmEnabled)) {
    return <Redirect to="/lgyhub/help" />
  }

  return <LgyLoadingFallback isLoading={user.fetching} isError={user.error}>
    <HelpTicketForm
      form='helpTicketForm'
      initialValues={initialFormValues}
      formValues={values}
      userIsLoggedIn={user.exists}
      user={user}
      serverProperties={serverProperties} />
  </LgyLoadingFallback>
}

// We can pull most of the help ticket form values from the store
export default connect((state) => ({
  initialFormValues: {
    username: state.currentUser.portalId,
    firstName: formatNameFull(state.currentUser),
    userType: userTypeString(state.currentUser),
    phoneNumber: phoneNumberStringFromUser(state.currentUser),
    email: state.currentUser.email,
    os: getOS(),
    browser: getBrowser().name,
    browserVersion: getBrowser().version
  },
  user: state.currentUser,
  serverProperties: state.serverProperties,
  values: getFormValues('helpTicketForm')(state) || {},
  isCsmEnabled: state.serverProperties?.isCsmEnabled === 'true',
  isCsmEnabledForAnonymousUsers: state.serverProperties?.isCsmEnabledForAnonymousUsers === 'true',
  userIsLoggedIn: !!(state?.currentUser?.registered),
}))(HelpTicketContainer)
